import React from 'react'

/**
 * Applies a button's content color to its icon node.
 *
 * Callers pass fully-rendered icon nodes, so the color is injected rather than
 * required up front. Two mechanisms are needed because the codebase mixes icon
 * families:
 *
 * - `Icon.tsx` hard-sets `color: white` by default and does not inherit, so it
 *   needs the `color` prop passed explicitly.
 * - antd icons and `currentColor` SVGs inherit from the wrapping element, which
 *   the button already sets.
 *
 * An icon that was given an explicit `color` by the caller keeps it — the
 * button only fills in the gap.
 */
export const renderIconWithColor = (
  icon: React.ReactNode,
  color: string
): React.ReactNode => {
  if (!React.isValidElement(icon)) {
    return icon
  }

  const existingColor = (icon.props as { color?: string })?.color

  if (existingColor) {
    return icon
  }

  return React.cloneElement(icon as React.ReactElement<{ color?: string }>, {
    color,
  })
}

export default renderIconWithColor
